import React from 'react'
import styled from 'styled-components'
import {
  calculateResponsiveSize,
  calculateMobileResponsiveSize,
  mediaMax,
} from 'styles/media-queries'
import { Link } from 'gatsby'

const invertColor = (color) => ({ $inverted }) =>
  !$inverted ? color : color === '--blue' ? '--light' : '--blue'

const key = () => ({ $key }) => $key

export const Element = styled((props) => <Link {...props} />)`
  font-family: 'Basis Grotesque Pro';
  font-size: ${calculateResponsiveSize(8)};
  font-weight: 700;
  line-height: ${calculateResponsiveSize(10.14)};
  letter-spacing: ${calculateResponsiveSize(2)};

  text-transform: uppercase;
  height: ${calculateResponsiveSize(18)};
  padding-top: ${calculateResponsiveSize(2)};
  padding-left: ${calculateResponsiveSize(20)};
  padding-right: ${calculateResponsiveSize(20)};

  flex: 0 0 auto;
  width: fit-content;
  min-width: ${calculateResponsiveSize(90)};

  cursor: pointer;
  text-decoration: none;

  transition: background-color 0.5s, color 0.5s;
  border-radius: ${calculateResponsiveSize(20)};

  background-color: var(${invertColor('--blue')});
  color: var(${invertColor('--light')});
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;

  &:visited {
    color: var(${invertColor('--light')});
  }
  &:hover {
    background-color: var(--mid);
    color: var(--light);
  }
  &.openState {
    overflow: hidden;
    & span {
      transition: 1s;
    }
    & span:last-child {
      position: absolute;
      left: 50%;
      transform: translateX(calc(-50% + ${calculateResponsiveSize(10)}));
      width: 100%;
      opacity: 0;
    }
  }

  .opened & {
    background-color: var(--light);
    color: var(--blue);
    &:hover {
      background-color: var(--mid);
      color: var(--light);
    }
  }
  &.light {
    color: var(--light);
    background-color: transparent;
    border: 1px solid var(--light);

    &:hover {
      background-color: var(--light);
      color: var(--black);
    }
  }
  &.lightBlue-green {
    color: var(--blue);
    background-color: transparent;
    border: 1px solid var(--blue);

    &:hover {
      background-color: var(--mid);
      color: var(--light);
      border: 1px solid var(--mid);
    }
  }
  &.light-green {
    color: var(--light);
    background-color: transparent;
    border: 1px solid var(--light);

    &:hover {
      background-color: var(--mid);
      color: var(--light);
      border: 1px solid var(--mid);
    }
  }
  &.lightFill-green {
    color: var(--black);
    background-color: var(--light);
    border: 1px solid var(--light);

    &:hover {
      background-color: var(--mid);
      color: var(--light);
      border: 1px solid var(--mid);
    }
  }

  &.w216 {
    width: ${calculateResponsiveSize(216)};
  }
  &.soon {
    pointer-events: none;
  }

  .opened.${({ $bkey }) => $bkey} & {
    &.openState {
      & span:first-child {
        transform: translateX(calc(-${calculateResponsiveSize(10)}));
        opacity: 0;
      }
      & span:last-child {
        transform: translateX(-50%);
        opacity: 1;
      }
    }
    &.lightBlue-green {
      color: var(--light);
      background-color: transparent;
      border: 1px solid var(--light);
    }
  }
  .opened & {
    &.lightBlue-green {
      color: var(--light);
      background-color: transparent;
      border: 1px solid var(--light);
    }
  }

  #header li & {
    min-width: ${calculateResponsiveSize(90)};
  }

  ${mediaMax('mobile')} {
    font-size: ${calculateMobileResponsiveSize(8)};
    line-height: ${calculateMobileResponsiveSize(10.14)};
    letter-spacing: ${calculateMobileResponsiveSize(2)};
    height: ${calculateMobileResponsiveSize(18)};
    padding-top: ${calculateMobileResponsiveSize(2)};
    min-width: ${calculateMobileResponsiveSize(90)};
    border-radius: ${calculateMobileResponsiveSize(20)};
    &.mob-wide {
      width: 100%;
    }
    #header li & {
      min-width: ${calculateMobileResponsiveSize(80)};
    }
  }
`
